(function () {
  "use strict";

  var e = {
    479: function _(e, t, r) {
      var _n,
          i = this && this.__extends || (_n = function n(e, t) {
        return (_n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
          }
        })(e, t);
      }, function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

        function r() {
          this.constructor = e;
        }

        _n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
      }),
          o = this && this.__awaiter || function (e, t, r, n) {
        return new (r || (r = Promise))(function (i, o) {
          function a(e) {
            try {
              c(n.next(e));
            } catch (e) {
              o(e);
            }
          }

          function s(e) {
            try {
              c(n.throw(e));
            } catch (e) {
              o(e);
            }
          }

          function c(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
              e(t);
            })).then(a, s);
          }

          c((n = n.apply(e, t || [])).next());
        });
      },
          a = this && this.__generator || function (e, t) {
        var r,
            n,
            i,
            o,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function s(o) {
          return function (s) {
            return function (o) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; a;) {
                try {
                  if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;

                  switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                    case 0:
                    case 1:
                      i = o;
                      break;

                    case 4:
                      return a.label++, {
                        value: o[1],
                        done: !1
                      };

                    case 5:
                      a.label++, n = o[1], o = [0];
                      continue;

                    case 7:
                      o = a.ops.pop(), a.trys.pop();
                      continue;

                    default:
                      if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                        a = 0;
                        continue;
                      }

                      if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                        a.label = o[1];
                        break;
                      }

                      if (6 === o[0] && a.label < i[1]) {
                        a.label = i[1], i = o;
                        break;
                      }

                      if (i && a.label < i[2]) {
                        a.label = i[2], a.ops.push(o);
                        break;
                      }

                      i[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }

                  o = t.call(e, a);
                } catch (e) {
                  o = [6, e], n = 0;
                } finally {
                  r = i = 0;
                }
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, s]);
          };
        }
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var s = r(253),
          c = r(742),
          u = r(463),
          l = r(754),
          d = function (e) {
        function t(t) {
          return e.call(this, {
            baseURL: t,
            responseType: "text",
            transformResponse: void 0
          }) || this;
        }

        return i(t, e), t.prototype.normalizeTransactionResponse = function (e) {
          var t = {
            from: e.from,
            to: e.to,
            hash: e.hash,
            secret: e.secret,
            blockHash: e.blockHash,
            blockNumber: c.numberToHex(e.blockNumber),
            status: !0 === e.status ? "0x1" : "0x0",
            input: e.input,
            contractAddress: e.contractAddress,
            timestamp: c.numberToHex(e.timestamp),
            value: c.numberToHex(e.value),
            confirmations: e.confirmations
          },
              r = c.normalizeTransactionObject(t);
          return r.confirmations = t.confirmations, r._raw.contractAddress && (r._raw.contractAddress = r._raw.contractAddress.toLowerCase()), r._raw.secret && (r.secret = c.remove0x(r._raw.secret)), r;
        }, t.prototype.ensureFeeInfo = function (e) {
          return o(this, void 0, void 0, function () {
            var t, r, n, i;
            return a(this, function (o) {
              switch (o.label) {
                case 0:
                  return e.fee && e.feePrice ? [3, 2] : [4, this.getMethod("getTransactionByHash")(e.hash)];

                case 1:
                  t = o.sent(), r = t.fee, n = t.feePrice, i = t._raw, e._raw.gas = i.gas, e._raw.gasPrice = i.gasPrice, e.fee = r, e.feePrice = n, o.label = 2;

                case 2:
                  return [2, e];
              }
            });
          });
        }, t.prototype.findAddressTransaction = function (e, t, r, n, i, s) {
          return void 0 === i && (i = 250), void 0 === s && (s = "desc"), o(this, void 0, void 0, function () {
            var o, c, u, l, d;
            return a(this, function (a) {
              switch (a.label) {
                case 0:
                  o = 1, a.label = 1;

                case 1:
                  return [4, this.nodeGet("/txs/" + e, {
                    limit: i,
                    page: o,
                    sort: s,
                    fromBlock: r,
                    toBlock: n
                  })];

                case 2:
                  if (c = a.sent(), 0 === (u = c.data.txs).length) return [2];
                  if (l = u.filter(function (e) {
                    return !0 === e.status;
                  }).map(this.normalizeTransactionResponse), d = l.find(t)) return [2, this.ensureFeeInfo(d)];
                  if (u.length < i) return [2];
                  a.label = 3;

                case 3:
                  return o++, [3, 1];

                case 4:
                  return [2];
              }
            });
          });
        }, t.prototype.findAddressEvent = function (e, t) {
          return o(this, void 0, void 0, function () {
            var r, n;
            return a(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, this.nodeGet("/events/" + e + "/" + t)];

                case 1:
                  return r = i.sent(), (n = r.data.tx) && !0 === n.status ? [2, this.ensureFeeInfo(this.normalizeTransactionResponse(n))] : [2];
              }
            });
          });
        }, t.prototype.findInitiateSwapTransaction = function (e) {
          return o(this, void 0, void 0, function () {
            var t = this;
            return a(this, function (r) {
              return this.validateSwapParams(e), [2, this.findAddressTransaction(u.addressToString(e.refundAddress), function (r) {
                return t.getMethod("doesTransactionMatchInitiation")(e, r);
              })];
            });
          });
        }, t.prototype.validateSwapParams = function (e) {
          u.validateValue(e.value), c.validateAddress(e.recipientAddress), c.validateAddress(e.refundAddress), u.validateSecretHash(e.secretHash), c.validateExpiration(e.expiration);
        }, t.prototype.findClaimSwapTransaction = function (e, t) {
          return o(this, void 0, void 0, function () {
            var r, n;
            return a(this, function (i) {
              switch (i.label) {
                case 0:
                  return this.validateSwapParams(e), [4, this.getMethod("getTransactionReceipt")(t)];

                case 1:
                  if (!(r = i.sent())) throw new l.PendingTxError("Transaction receipt is not available: " + t);
                  return [4, this.findAddressEvent("swapClaim", r.contractAddress)];

                case 2:
                  return (n = i.sent()) ? (u.validateSecretAndHash(n.secret, e.secretHash), [2, n]) : [2];
              }
            });
          });
        }, t.prototype.findRefundSwapTransaction = function (e, t) {
          return o(this, void 0, void 0, function () {
            var r;
            return a(this, function (n) {
              switch (n.label) {
                case 0:
                  return this.validateSwapParams(e), [4, this.getMethod("getTransactionReceipt")(t)];

                case 1:
                  if (!(r = n.sent())) throw new l.PendingTxError("Transaction receipt is not available: " + t);
                  return [2, this.findAddressEvent("swapRefund", r.contractAddress)];
              }
            });
          });
        }, t.prototype.doesBlockScan = function () {
          return !1;
        }, t;
      }(s.NodeProvider);

      t.default = d;
    },
    175: function _(e, t, r) {
      var n = this && this.__createBinding || (Object.create ? function (e, t, r, n) {
        void 0 === n && (n = r), Object.defineProperty(e, n, {
          enumerable: !0,
          get: function get() {
            return t[r];
          }
        });
      } : function (e, t, r, n) {
        void 0 === n && (n = r), e[n] = t[r];
      }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
        Object.defineProperty(e, "default", {
          enumerable: !0,
          value: t
        });
      } : function (e, t) {
        e.default = t;
      }),
          o = this && this.__importStar || function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var r in e) {
          "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
        }
        return i(t, e), t;
      },
          a = this && this.__importDefault || function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.scraper = t.EthereumScraperSwapFindProvider = void 0;
      var s = a(r(479));
      t.EthereumScraperSwapFindProvider = s.default;
      var c = o(r(298));
      t.scraper = c;
    },
    298: function _(e, t) {
      Object.defineProperty(t, "__esModule", {
        value: !0
      });
    },
    754: function _(e) {
      e.exports = require("@liquality/errors");
    },
    742: function _(e) {
      e.exports = require("@liquality/ethereum-utils");
    },
    253: function _(e) {
      e.exports = require("@liquality/node-provider");
    },
    463: function _(e) {
      e.exports = require("@liquality/utils");
    }
  },
      t = {},
      r = function r(n) {
    var i = t[n];
    if (void 0 !== i) return i.exports;
    var o = t[n] = {
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.exports;
  }(175);

  module.exports = r;
})();